import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
  BasicCartesianChartColourPalette,
} from '@app/data/widget-config-templates/basic-cartesian-chart';

export const RainfallHakaruRiver: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093'],
    tooltip: {
      ...BasicCartesianChartEchartConfigTemplate.tooltip,
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      ...BasicCartesianChartEchartConfigTemplate.xAxis,
      boundaryGap: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm/hr',
        boundaryGap: undefined,
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm',
        position: 'right',
        boundaryGap: undefined,
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'bar',
        yAxisIndex: 0,
        name: 'mm/hr (avg)',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'mm (total)',
      },
    ],
  },
  dataConfig: {
    title: 'Hakaru River Rainfall (Hakaru at Tara)',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_hakaru_attara',
        analyteIdentifier: 'precipitation',
        valueField: 'avg',
        label: 'Precipitation',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_hakaru_attara',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Precipitation',
      },
    ],
  },
};

export const RainfallKaiparaHarbour: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093'],
    tooltip: {
      ...BasicCartesianChartEchartConfigTemplate.tooltip,
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      ...BasicCartesianChartEchartConfigTemplate.xAxis,
      boundaryGap: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm/hr',
        boundaryGap: undefined,
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm',
        position: 'right',
        boundaryGap: undefined,
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'bar',
        yAxisIndex: 0,
        name: 'mm/hr (avg)',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'mm (total)',
      },
    ],
  },
  dataConfig: {
    title: 'Kaipara Harbour Rainfall (Pouto Point)',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_kaipara_harbouratpoutopoint',
        analyteIdentifier: 'precipitation',
        valueField: 'avg',
        label: 'Precipitation',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_kaipara_harbouratpoutopoint',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Precipitation',
      },
    ],
  },
};

export const RainfallPaparoaMaungaturoto: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093'],
    tooltip: {
      ...BasicCartesianChartEchartConfigTemplate.tooltip,
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      ...BasicCartesianChartEchartConfigTemplate.xAxis,
      boundaryGap: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm/hr',
        boundaryGap: undefined,
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm',
        position: 'right',
        boundaryGap: undefined,
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'bar',
        yAxisIndex: 0,
        name: 'mm/hr (avg)',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'mm (total)',
      },
    ],
  },
  dataConfig: {
    title: 'Paparoa Rainfall (Maungaturoto)',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_paparoa_atmaungaturoto',
        analyteIdentifier: 'precipitation',
        valueField: 'avg',
        label: 'Precipitation',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_paparoa_atmaungaturoto',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Precipitation',
      },
    ],
  },
};

export const RainfallPaparoaTaylors: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093'],
    tooltip: {
      ...BasicCartesianChartEchartConfigTemplate.tooltip,
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      ...BasicCartesianChartEchartConfigTemplate.xAxis,
      boundaryGap: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm/hr',
        boundaryGap: undefined,
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'mm',
        position: 'right',
        boundaryGap: undefined,
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'bar',
        yAxisIndex: 0,
        name: 'mm/hr (avg)',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'mm (total)',
      },
    ],
  },
  dataConfig: {
    title: 'Paparoa Rainfall (Taylors)',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_paparoa_attaylors',
        analyteIdentifier: 'precipitation',
        valueField: 'avg',
        label: 'Precipitation',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_paparoa_attaylors',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Precipitation',
      },
    ],
  },
};

export const UaHakaruRiver: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#00b1d8'],
    grid: {
      top: '25%',
      left: '8%',
      right: '8%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Rainfall\nmm',
        position: 'right',
        inverse: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00b1d8',
          },
        },
        axisLabel: {
          color: '#00b1d8',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Flow',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Rainfall',
        areaStyle: {},
        itemStyle: {
          opacity: 0.3,
        },
        emphasis: {
          focus: 'series',
        },
        lineStyle: {
          width: 1,
        },
        markArea: {
          silent: true,
          itemStyle: {
            opacity: 0.3,
          },
        },
      },
    ],
  },
  dataConfig: {
    title: 'UA - Rainfall and Relative Water Level: Hakaru River (Topuni Creek Farm)',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_hakaru_attopunicreekfarm',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Water Flow',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_hakaru_attopunicreekfarm',
        analyteIdentifier: 'precipitation',
        valueField: 'sum',
        label: 'Rainfall',
      },
    ],
  },
};

export const LakeKanonoFlow: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Flow',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Wai Flow: Lake Kanono at SG Kanono Outlet Pouto',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_lake_kanonoatsgkanonooutletpouto',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Flow',
      },
    ],
  },
};

export const WaterTemperatureMangawhai: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#00b1d8 ', '#ee4891', '#007093'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6894cd',
          },
        },
        axisLabel: {
          color: '#6894cd',
        },
      },
    ],
    series: [
      {
        type: 'line',
        lineStyle: {
          color: '#00b1d8',
        },
        name: 'Mangawhai at Medical centre',
        symbolSize: 13,
      },
      {
        type: 'line',
        lineStyle: {
          color: '#ee4891',
        },
        name: 'Mangawhai GW at Molesworth Drive Golf',
        symbolSize: 13,
      },
      {
        type: 'line',
        lineStyle: {
          color: '#007093',
        },
        name: 'Mangawhai Heads GW at Estuary Drive',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Water Temperature: Mangawhai (Medical Centre, Molesworth Drive, Estuary Drive)',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'nrc_mangawhai_atmedicalcentre',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Mangawhai at Medical centre',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_mangawhai_gwatmolesworthdrivegolfnrcbore',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Mangawhai GW at Molesworth Drive Golf',
      },
      {
        environmentalDataSourceIdentifier: 'nrc_mangawhai_headsgwatestuarydrivenrcbore',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Mangawhai Heads GW at Estuary Drive',
      },
    ],
  },
};
